module.exports = __webpack_public_path__ + "epdf-app/dashboard/folder/folder-66OpFieI.html";